let router = [
    {
        //页面登录
        path: '/front/login',
        name: 'front_login',
        component: (resolve) => require(['@/views/front/login'], resolve),
    },
    {
        //注册
        path: '/front/register',
        name: 'front_register',
        component: (resolve) => require(['@/views/front/register'], resolve),
    },
    {
        //授权成功
        path: '/front/auth',
        name: 'front_auth',
        component: (resolve) => require(['@/views/front/auth'], resolve),
    },
    {
        //登录
        path: '/auth/auth_login',
        name: 'auth_login',
        component: (resolve) => require(['@/views/front/auth_login'], resolve),
    },
    {
        //店铺列表
        path: '/auth/auth_shop',
        name: 'auth_shop',
        component: (resolve) => require(['@/views/front/auth_shop'], resolve),
    },
    {
        //授权回调
        path: '/auth/auth_result',
        name: 'auth_result',
        component: (resolve) => require(['@/views/front/auth_result'], resolve),
    },
     {
        //授权回调
        path: '/front/auth_download',
        name: 'front_download',
        component: (resolve) => require(['@/views/front/download.vue'], resolve),
    },
    {
        //授权成功
        path: '/front/taoworld',
        name: 'front_taoworld',
        component: (resolve) => require(['@/views/front/taoworld.vue'], resolve),
    },
]
export default router;